module.exports = __webpack_public_path__ + "media/images/brands/marque-essie@2x-72ecccf94c8347ff66ab6ed122c3b4c6.jpg";